/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_PaymentInputs */

const vi_customer_payment = /** @type {(inputs: Customer_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách thanh toán`)
};

/**

* @param {Customer_PaymentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_payment = /** @type {((inputs?: Customer_PaymentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_PaymentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_payment(inputs)
});